import React, { useState, useEffect } from 'react'
import { Box, Button, Text, Layer } from 'grommet'
import { Close } from 'grommet-icons'

import AppDataAvailabilityHistory from './AppDataAvailabilityHistory'
import AccountRiskLimits from './RiskLimits'
import AppDataGraphAccount from './AppDataGraphAccount'

import TTJsonTree from './TTJsonTree'
import TTabSub from './TTabSub'
import { themeBalham } from 'ag-grid-community';

import TriageViewLogHistory from '../triage/TriageViewLogHistory'
import TriageViewResult from '../triage/TriageViewResult'
import TriageGroupResult from '../triage/jobtask/recent/TriageGroupResult'
import TriageSnapshotResult from '../triage/TriageSnapshotResult'
import TriagePsClientResult from '../triage/TriagePSClientResult'
import TriageGroupSnapshot from '../triage/TriageGroupSnapshot'
//import FixMetricsViewResult from './FixMetricsViewResult'
import TriageProgressView from '../triage/TriageProgressView'
import TriageRoutingLibaryResult from '../triage/TriageRoutingLibraryResult'
import TriageKibanaView from '../triage/TriageKibanaView'

// TriageHistory
import TriageHistoryViewLog from '../triage/jobtask/history/TriageHistoryViewLog'
import TriageHistoryViewResult from '../triage/jobtask/history/TriageHistoryViewResult'

import FixParserHome from '../fix/FixParserHome'
import { AccountDetailView, NodeServiceView, FixDataView, SessionHistoryView, SessionDetailView } from './AgDataTableSlideViews'

import { AgGridReact } from 'ag-grid-react'

const ParamsComponent = ({ data, objkey }) => {
  let parmobj = {}

  if (objkey !== 'Params') {
    parmobj = data[objkey]
  }
  else if (typeof (JSON.parse(data[objkey])) === 'object') {
    parmobj = JSON.parse(data[objkey])
  } else {
    parmobj = JSON.parse(JSON.parse(data[objkey]))
  }

  return (
    <Box fill={true} direction="row" wrap={true} gap="small">
      {objkey === 'Params' ?
        <TTJsonTree data={parmobj} expandAll={true} />
        : parmobj
      }
    </Box>
  )
}

const AppDataTableDetail = ({ detailView, defaultSubTab }) => {
  const [hideView, setHideView] = useState(false)

  const toggleView = () => {
    setHideView(!hideView)
  }

  useEffect(() => {
    setHideView(false)
  }, [detailView])


  return (
    <>
      {!hideView && (

        <Layer
          full={true}
          margin={{ top: "25px", left: "350px" }}
          position="right"
          modal={true}
          onEsc={toggleView}
          onClickOutside={toggleView}
        >

          <Box name="tabletab" gap="small" alignContent="start" background="light-2" fill="vertical">
            <Box flex={false} fill="horizontal" direction="row">
              <Box direction="row" fill="horizontal" background="light-3" border="horizontal" pad="xsmall" gap="xsmall">

                {Object.keys(detailView.head).map(headKey => (
                  <Box fill="horizontal" key={headKey} direction="column" gap="small" wrap={true} pad="xsmall">
                    <Box width="500px">
                      <Text size="xsmall" weight="bold" color="brand">
                        {headKey}
                      </Text>
                      <ParamsComponent
                        data={detailView.head}
                        objkey={headKey}
                      />
                    </Box>
                  </Box>
                ))}

                <Box fill="horizontal" background="light-3" align="end" justify="start" alignContent="start">
                  <Button
                    hoverIndicator={{ color: 'light-1', opacity: 'medium' }}
                    icon={<Close color="ttdown" size="10px" />}
                    onClick={toggleView}
                  />
                </Box>
              </Box>
            </Box>

            <AppDataTableContent
              data={detailView.data}
              defaultSubTab={defaultSubTab}
            />

          </Box>
        </Layer>
      )}
    </>
  )
}

const AppDataTableContent = ({ data, defaultSubTab }) => {

  const [selectedSubTab, setSelectedSubTab] = useState(defaultSubTab)

  return (
    <Box direction='column'>
      <Box direction="row" align="start" justify="start">
        {data &&
          data.map(data => (
            <TTabSub
              key={data.subheader}
              subTabName={data.subheader}
              handleClickSubTab={() => setSelectedSubTab(data.subheader)}
              selected={selectedSubTab === data.subheader}
            />
          ))}
      </Box>
      <Box height="97%" overflow={{ horizontal: 'hidden', vertical: 'auto' }} background="light-2">
        {data &&
          data.map(data => {
            if (selectedSubTab === data.subheader && data.type === 'json' && data.content) {
              return <TTJsonTree key={data.subheader + '_data'} data={data.content} />
            } else if (selectedSubTab === data.subheader && data.type === 'table' && data.content) {
              return (
                <Box
                  height={1500 + "px"}
                  width="100%"
                  margin={{ top: "20px" }}
                  key={data.subheader + '_data'}
                >
                  <AgGridReact
                    theme={themeBalham}
                    rowHeight={30} rowSelection={true} enableCellTextSelection={true}
                    pagination={true} paginationPageSize={50}
                    defaultColDef={
                      {
                        sortable: true,
                        filter: true,
                        resizable: true,
                        cellStyle: { 'fontSize': '12px', 'fontFamily': "'Metrophobic', sans-serif" },
                        floatingFilter: false,
                      }
                    }
                    columnDefs={data.content.tab_col}
                    rowData={data.content.tab_data}
                  />
                </Box>
              )

            } else if (selectedSubTab === data.subheader && data.type === 'api_availability_history' && data.content) {
              return <AppDataAvailabilityHistory key={data.subheader + '_data'} url={data.content.url} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'account_risk_limits' && data.content) {
              return <AccountRiskLimits key={data.subheader + '_data'} accountId={data.content.accountId} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'node_service' && data.content && data.content.instance) {
              return <NodeServiceView key={data.subheader + '_data'} instance={data.content.instance} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'account_detail' && data.content) {
              return <AccountDetailView key={data.subheader + '_data'} accountId={data.content.accountId} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'session_history' && data.content) {
              return <SessionHistoryView key={data.subheader + '_data'} sessionData={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_kibana_view' && data.content) {
              return <TriageKibanaView key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'session_details' && data.content) {
              return <SessionDetailView key={data.subheader + '_data'} sessionData={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_log' && data.content) {
              return <TriageViewLogHistory key={data.subheader + '_data'} taskid={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_result' && data.content) {
              return <TriageViewResult key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_history_result' && data.content) {
              return <TriageHistoryViewResult key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_history_log' && data.content) {
              return <TriageHistoryViewLog key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_group_result' && data.content) {
              return <TriageGroupResult key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_snapshot_result' && data.content) {
              return <TriageSnapshotResult key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_psclient_result' && data.content) {
              return <TriagePsClientResult key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_progress_view' && data.content) {
              return <TriageProgressView key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_group_snapshot' && data.content) {
              return <TriageGroupSnapshot key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_fix_parser' && data.content) {
              return <FixParserHome key={data.subheader + '_data'} content={data.content} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'triage_routing_library_parser' && data.content) {
              return <TriageRoutingLibaryResult key={data.subheader + '_data'} content={data.content} />
            }
            // else if (selectedSubTab === data.subheader && data.type === 'fix_app' && data.content) {
            //   return <FixMetricsViewResult key={data.subheader + '_data'} clientCompId={data.content.clientCompId} fixType={data.content.fixType} />
            // }
            else if (selectedSubTab === data.subheader && data.type === 'fix_data' && data.content) {
              return <FixDataView key={data.subheader + '_data'} fixSessionId={data.content.fixSessionId} />
            }
            else if (selectedSubTab === data.subheader && data.type === 'graph_account' && data.content) {
              return <AppDataGraphAccount key={data.subheader + '_data'} accountId={data.content.accountId} />
            } else {
              return <Box />
            }
          })}
      </Box>
    </Box>
  )
}

export default AppDataTableDetail
